import { LocalStorage } from "../storages/local/LocalStorage";
class CustomTime {
    //#region constructor
    constructor() {
        this.localStorage = new LocalStorage();
        this.storageKey = "CustomTime";
    }
    //#endregion 
    //#region public
    set(dateVal) {
        this.localStorage.set(this.storageKey, dateVal);
    }
    get() {
        let customDate = this.localStorage.get(this.storageKey);
        // this returns the current date/time based on either the current real datetime or a datetime set in the debug panel.
        if (customDate) {
            return new Date(Date.parse(customDate));
        }
        else {
            // no custom time set, so return the current moment object.
            return new Date();
        }
    }
    getDate() {
        let date = this.get();
        date.setHours(0, 0, 0, 0);
        return date;
    }
    getUTCDate() {
        let date = this.get();
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    delete() {
        this.localStorage.delete(this.storageKey);
    }
    checkLocalStorage() {
        return !!this.localStorage.get(this.storageKey);
    }
    formatDate(date, formatedDate = 'M/D/Y h:m:s') {
        var convertTo2digit = function (elem) {
            return ('0' + String(elem)).slice(-2);
        };
        return formatedDate
            .replace('Y', String(date.getFullYear()))
            .replace('M', convertTo2digit(date.getMonth() + 1))
            .replace('D', convertTo2digit(date.getDate()))
            .replace('h', convertTo2digit(date.getHours()))
            .replace('m', convertTo2digit(date.getMinutes()))
            .replace('s', convertTo2digit(date.getSeconds()));
    }
    formatUtcDate(date, formatedDate = 'M/D/Y h:m:s') {
        var convertTo2digit = function (elem) {
            return ('0' + String(elem)).slice(-2);
        };
        return formatedDate
            .replace('Y', String(date.getUTCFullYear()))
            .replace('M', convertTo2digit(date.getUTCMonth() + 1))
            .replace('D', convertTo2digit(date.getUTCDate()))
            .replace('h', convertTo2digit(date.getUTCHours()))
            .replace('m', convertTo2digit(date.getUTCMinutes()))
            .replace('s', convertTo2digit(date.getUTCSeconds()));
    }
    convertToUtcTime(dateString) {
        return this.convertWithTimeZone(dateString, '+00:00');
    }
    convertWithTimeZone(dateString, timeZone = '+00:00') {
        let date = new Date(dateString + timeZone);
        if (isNaN(date.getDate())) {
            date = new Date(dateString + ' 00:00:00' + timeZone);
            if (isNaN(date.getDate())) {
                return new Date(dateString);
            }
        }
        return date;
    }
}
export const customTime = new CustomTime();
